import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import InvitationForm from '../../../ProShare/components/InvitationForm';
import { breakpointDown } from '../../../../../../../../services/responsive/responsive';

const propTypes = {
  sendInvites: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

const EmailStep = ({ sendInvites, onSuccess, submitting }) => {
  const isMobile = useMediaQuery(breakpointDown('sm'));

  return (
    <InvitationForm
      sendInvites={sendInvites}
      onSuccess={onSuccess}
      submitting={submitting}
      allowInputTypeSelection={false}
      helperText={`Add email and ${
        isMobile ? 'tap [return]' : 'press [enter]'
      }`}
    />
  );
};

EmailStep.propTypes = propTypes;

export default EmailStep;
